import { useRef, useEffect } from 'react';
import { Flex, TextField } from '@radix-ui/themes';

import styles from '../vault.module.css';

export const EditableInput = ({ value, onChange }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <Flex align="center" width="100%" position="relative">
      <TextField.Root
        className={styles.editFileInput}
        ref={inputRef}
        value={value}
        onChange={e => onChange(e.target.value)}
        onMouseDown={e => e.stopPropagation()}
      />
    </Flex>
  );
};
